import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useWorkOrderDND = () => {
  const [searchParams] = useSearchParams();
  const workOrderParams = useMemo(
    () => ({
      search: searchParams.get("search"),
      start_date: searchParams.get("work_order_from"),
      end_date: searchParams.get("work_order_to"),
    }),
    [searchParams],
  );
  return {
    workOrderParams,
  };
};
